import { removeItem, setItem } from "../utils/handleLocalStorage";

const LOGOUT_URL = import.meta.env.VITE_LOGOUT_URL;
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL;

export const logoutUser = async () => {
  let token = localStorage.getItem("token");

  if (!token) return;

  // Eliminar comillas del token
  token = token.replace(/['"]+/g, '');

  try {
    const response = await fetch(LOGOUT_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      redirect: 'manual'
    });

    if (response.status === 302 || response.status === 0 || response.ok) {
      removeItem("token");
      removeItem("oauthCodeProcessed");

      // Marcar que el usuario está cerrando sesión
      setItem("isLoggingOut", "true");

      // Redirigir al usuario a la página de login
      window.location.href = LOGIN_URL;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("❌ Error en logoutUser:", error);
    throw error; // Mantiene el manejo de errores si realmente es un fallo
  }
};